const updateDigitalPrices = () => {
  const select = document.querySelector('[data-translation-shop-currency]');
  const selected = select?.selectedOptions[0];
  const base = Number([...select?.options || []].find(option => option.value === 'EUR')?.dataset.rate);
  const rate = Number(selected?.dataset.rate);
  const currency = base > 0 && rate > 0 ? selected.value : 'EUR';
  const amount = currency === 'EUR' ? 9.9 : 9.9 * rate / base;
  const price = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(amount);
  document.querySelectorAll('[data-alpha-digital-display-price]').forEach(node => {
    if (node.textContent !== price) node.textContent = price;
  });
};
let queued = false;
const scheduleDigitalPrices = () => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => { queued = false; updateDigitalPrices(); });
};
document.addEventListener('change', event => {
  if (event.target.matches('[data-translation-shop-currency]')) scheduleDigitalPrices();
});
window.addEventListener('alpha:artwork-browse', scheduleDigitalPrices);
new MutationObserver(scheduleDigitalPrices).observe(document.body, {childList:true,subtree:true});
updateDigitalPrices();
